import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/location/importer/locationImporterActions';

export default importerReducers(actions);
